import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Toast.css';

const Toast = ({ message, type = 'info', duration = 3000, position = 'bottom', onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300); // Allow animation to finish
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const variants = {
    hidden: { opacity: 0, y: position === 'bottom' ? 50 : -50 },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: position === 'bottom' ? 50 : -50 },
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className={`toast toast-${type} toast-${position}`}
          variants={variants}
          initial="hidden"
          animate="visible"
          exit="exit"
          transition={{ duration: 0.3 }}
        >
          <span>{message}</span>
          <button className="toast-close" onClick={() => setIsVisible(false)}>×</button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;